import React, { useEffect, useState } from "react";
import Layouts from "../../components/Layouts";
import { Button, Modal, Space, Table } from "antd";
import { getDirectusClient } from "../../lib/directus";
import { Link } from "react-router-dom";
import { readItems, readMe, updateItem, updateItems } from "@directus/sdk";
import { useSelector } from "react-redux";

function Aceptartraslado(props) {
  const [modal, setModal] = useState(false);
  const userBodega = useSelector((state) => state.userdata);
  const [seriales, setSeriales] = useState([]);
  const columns = [
    {
      title: "Bodega",
      dataIndex: "bodega",
      key: "bodega",
      render: (record) => {
        return <p>{record.nombre}</p>;
      },
    },
    {
      title: "Bodega destino",
      dataIndex: "bodega_destino",
      key: "bodega_destino",
      render: (record) => {
        return <p>{record.nombre}</p>;
      },
    },
    {
      title: "Estado",
      dataIndex: "estado",
      key: "estado",
    },
    {
      title: "Creado por",
      dataIndex: "user_created",
      key: "user_created",
      render: (record) => {
        return <p>{record.first_name}</p>;
        console.log(record.first_name);
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            onClick={() => {
              consultarseriales(record.id, false, record.bodega_destino);
              //console.log(record.bodega_destino);
              setModal(true);
            }}
          >
            Ver seriales
          </Button>
          <a
            onClick={() => {
              Aceptartraslado(record.id, record.bodega_destino);
            }}
          >
            Aceptar Traslado
          </a>
        </Space>
      ),
    },
  ];

  const Aceptartraslado = (id, bodegadestino) => {
    let aceptar = true;
    consultarseriales(id, aceptar, bodegadestino);
  };
  const cerrarModal = () => {
    setModal(false);
  };

  const consultarseriales = async (id, aceptar, destino) => {
    const directus = await getDirectusClient();

    if (aceptar) {
      try {
        // Get serials filtered by bodega
        const serialesToUpdate = await directus.request(
          readItems('seriales', {
            fields: ['id', 'serial'],
            filter: {
              solicitud_traslado: {
                solicitud_traslado_id: { _eq: id }
              },
              bodega: { id: { _eq: userBodega.bodega.id }}
            }
          })
        );
  
        // Update serials status and location
        const updatedSerials = await directus.request(
          updateItems('seriales', 
            serialesToUpdate.map(serial => serial.id),
            {
              estado: 1,
              bodega: destino.id,
            }
          )
        );
  
        // Update traslado status
        await directus.request(
          updateItem('solicitud_traslado', id, {
            estado: "aceptado",
          })
        );
  
        // Get historial entries for these serials
        const historialIds = await directus.request(
          readItems('historial_traslado', {
            fields: ['id'],
            filter: {
              serial: {
                _in: serialesToUpdate.map(s => s.id)
              }
            }
          })
        );
  
        // Update historial_traslado entries
        if (historialIds.length > 0) {
          await directus.request(
            updateItems('historial_traslado',
              historialIds.map(h => h.id),
              {
                estado: "aceptado",
                acaptado_por: userBodega.id,
                aceptado_fecha: new Date().toISOString(),
                anulado_por: null
              }
            )
          );
        }
  
        Modal.success({
          title: "Éxito",
          content: `Se aceptó el traslado. ${updatedSerials.length} seriales fueron trasladados a tu bodega`,
        });
        
        consultaTraslados();
      } catch (error) {
        console.error('Error:', error);
        Modal.error({
          title: "Error",
          content: "No se pudo procesar el traslado",
        });
      }
    } else {
      // Update the seriales query for viewing
      await directus.request(
        readItems('seriales', {
          fields: ["*"],
          limit: -1,
          filter: {
            solicitud_traslado: {
              solicitud_traslado_id: { _eq: id }
            },
            bodega: { id: { _eq: userBodega.bodega.id }}
          }
        })
      ).then((seriales) => {
        setSeriales(seriales);
      });
    }
  };
  const [traslados, setTraslados] = useState([]);


  const consultaTraslados = async () => {
    const directus = await getDirectusClient();
    await directus.request(
      readItems('solicitud_traslado', {
        fields: ['*.*'],
        filter: {
          _and: [
            { estado: { _eq: 'iniciado' }},
            {
              _or: [
                { bodega: { id: { _eq: userBodega.bodega.id }}},
                { bodega_destino: { id: { _eq: userBodega.bodega.id }}}
              ]
            }
          ]
        }
      })
    ).then((res) => {
      setTraslados(res);
    });
  };

  useEffect(() => {
    consultaTraslados();
  }, []);
  return (
    <Layouts>
      <Table columns={columns} dataSource={traslados} />
      <Modal onOk={cerrarModal} onCancel={cerrarModal} open={modal}>
        {seriales.map((serial) => {
          return (
            <Space size={"small"}>
              <p>{"- " + serial.serial} </p>
            </Space>
          );
        })}
      </Modal>
    </Layouts>
  );
}

export default Aceptartraslado;
